// The filter key names, these need to match the queryParam value specified from the API data on each of the filter options
export const QUERY_PARAM_SORT = 'currentSort';
export const QUERY_PARAM_PAGE = 'currentPage';
export const QUERY_PARAM_MODAL = 'modal';
export const QUERY_PARAM_LOCATION = 'modalID';
// export const QUERY_PARAM_LOCATION = 'location';
